import React from 'react';
import { Box, Link, Text } from '@chakra-ui/react';

function Footer() {
  return (
    <Box alignSelf="flex-end" width="100%" bg="gray.100" align="right" p="2" marginTop="2">
      <Text fontSize="xs">Powered By</Text>
      <Link href="https://vetdrive.co" isExternal style={{ textDecoration: 'none' }}>
        <Text fontSize="lg" as="b">Vetdrive</Text>
      </Link>

    </Box>
  );
}

export default Footer;
